export function debounce(func, wait, immediate) {
	var timeout;
	return (...args) => {
		var context = this;
		var later = () => {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}
/*
const debounce = function(func, delay = 300){
      let timer;
      return function () {     //anonymous function
        const context = this; 
		const args = arguments;
		clearTimeout(timer); 
		timer = setTimeout(()=> {
	    	func.apply(context, args)
		},delay);
    }
}
*/